import { render, staticRenderFns } from "./supplierHeadList.vue?vue&type=template&id=024ab578&scoped=true&"
import script from "./supplierHeadList.vue?vue&type=script&lang=js&"
export * from "./supplierHeadList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024ab578",
  null
  
)

export default component.exports